import { useNavigate, useLocation } from "react-router-dom";
import { IoSettingsOutline, IoLogOutOutline } from "react-icons/io5";
import { GoPeople } from "react-icons/go";
import { RiDashboardLine } from "react-icons/ri";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { BsChevronLeft } from "react-icons/bs";
import { IconType } from "react-icons";
import logo from "../../../assets/images/logo.svg";
import { useState } from "react";
import { useDeleteAccount } from "../../../api/authApi";
import ConfirmationDialog from "../../../components/ConfirmationDialog";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const navigate = useNavigate();
  const pathname = useLocation().pathname.split("/")[1];
  console.log(pathname);

  const deleteAccountMutation = useDeleteAccount();

  const handleDeleteAccountClick = () => {
    setShowDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteAccountMutation.mutateAsync();
      // Clear local storage and redirect to login on success
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/login";
    } catch (error) {
      console.error("Failed to delete account:", error);
      // Handle error - could show a toast notification here
    } finally {
      setShowDeleteDialog(false);
    }
  };

  interface SidebarItem {
    name: string;
    path: string;
    icon: IconType;
    subItems?: SidebarItem[];
  }

  const sidebarItems: SidebarItem[] = [
    {
      name: "inbox",
      path: "/inbox",
      icon: RiDashboardLine,
    },
    {
      name: "contact",
      path: "/contact",
      icon: GoPeople,
    },
    {
      name: "settings",
      path: "/settings",
      icon: IoSettingsOutline,
    },
  ];

  return (
    <aside
      className={`${
        isCollapsed ? "w-20" : "w-[200px]"
      } bg-white border-r border-gray-200 flex flex-col transition-all duration-300`}
    >
      <div className="flex items-center justify-between border-b border-gray-200 px-5 py-5">
        <img
          src={logo}
          alt="Logo"
          className={`h-8 ${isCollapsed ? "hidden" : "block"}`}
        />
        <button
          className="w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-[#78C7D1] rounded-full transition-transform duration-300"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? <HiOutlineMenuAlt2 /> : <BsChevronLeft />}
        </button>
      </div>

      <nav className="flex-1 py-5">
        <ul>
          {sidebarItems.map((item) => (
            <li key={item.name} className="relative cursor-pointer">
              <div
                className={`flex items-center ${
                  isCollapsed ? "justify-center px-0" : "px-5"
                } py-3 mx-2 rounded-lg cursor-pointer transition-all duration-200 ${
                  pathname.includes(item.name)
                    ? "bg-gray-300 text-gray-600"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
                onClick={() => {
                  navigate(item.path);
                }}
              >
                <item.icon
                  className={`text-xl ${isCollapsed ? "mr-0" : "mr-3"}`}
                />
                {!isCollapsed && <span>{item.name}</span>}
                {!isCollapsed && item.subItems && (
                  <span className="ml-auto transition-transform duration-300">
                    ▸
                  </span>
                )}
              </div>
              {item.subItems && (
                <ul className="hidden group-hover:block absolute left-full top-0 min-w-[160px] bg-white border border-gray-200 rounded-md shadow-md py-2 z-10">
                  {item.subItems.map((subItem) => (
                    <li
                      key={subItem.name}
                      onClick={() => {
                        navigate(subItem.path);
                      }}
                      className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                    >
                      <subItem.icon className="text-xl" />
                      <span>{subItem.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <button
        onClick={handleDeleteAccountClick}
        className="w-full rounded-lg flex items-center justify-center px-4 py-2 bg-red-500 text-white hover:bg-red-600"
      >
        <IoLogOutOutline className="text-xl" />
        <span className="text-sm">delete account and data</span>
      </button>
      <div className="px-5 py-5">
        <div className="flex items-center mb-4">
          <div className="relative w-10 h-10 bg-gray-200 text-black rounded-full flex items-center justify-center font-medium">
            <span>TR</span>
            <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-green-500 rounded-full"></div>
          </div>
          {!isCollapsed && (
            <div className="ml-3">
              <h4 className="text-sm text-gray-800 m-0">Thomas Rights</h4>
            </div>
          )}
        </div>
      </div>

      <ConfirmationDialog
        isOpen={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        onConfirm={handleConfirmDelete}
        title="Delete Account"
        message="Are you sure you want to delete your account and all associated data? This action cannot be undone."
        confirmText="Delete Account"
        cancelText="Cancel"
        isLoading={deleteAccountMutation.isPending}
        variant="danger"
      />
    </aside>
  );
};

export default Sidebar;
